
import React, { useState } from "react";
import './_GenericGamesAndSurvey.scss'
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { Paths } from "../../routes/routePaths";
import { getProfileDetail } from '../../../Actions/ProfileAction';
import GameSection from "../../CommonComponent/GameSection";

const GenericGamesAndSurvey = ({ isHeaderManu }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const { profileReducer, gamesDetailsReducer } = useSelector(state => state)
    const profileDetail = profileReducer?.profileDetail?.data?.user
    const [questionSubmittedData, setQuestionSubmittedData] = useState({})
    const { games } = gamesDetailsReducer
    useEffect(() => {
        dispatch(getProfileDetail())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (profileDetail?.id) {
            checkMturkSteps()
        }
        // eslint-disable-next-line 
    }, [profileDetail, games])

    const checkMturkSteps = () => {
        if (profileDetail && profileDetail?.id) {
            const { feedback_submitted, survey_submitted, game_completion } = profileDetail

            let isGameCompleted = Object.values(game_completion)
            let gameCompleted = games.filter(item => item?.gamecompleted)
            
            setQuestionSubmittedData({
                disabledsurveyButton: (games.length !== gameCompleted?.length) || isGameCompleted.includes(false) || survey_submitted ? true : false,
                feedbackSubmitted: feedback_submitted,
                questionnaireSubmitted: survey_submitted
            })
        }
    }

    const handleNavigation = (isDisabled, type) => {
        if (!isDisabled) {
            let url = type === 'Feedback' ? Paths.GenericFeedback : Paths.GenericIntroduction
            history.push(url)
        }
    }

    return (
        <>
            <main className="talwind-dashboard max-w-xs mx-auto pt-24 pb-20 flex flex-col gap-6 w-full transition-all duration-300 sm:max-w-[420px] md:max-w-[calc(100vw-80px)] md:pl-16" >
                <div id="main_section" className={isHeaderManu ? "flex flex-col gap-6 transition-all duration-30 md:w-[72%] lg:w-[79%] xl:w-[84.5%] 2xl:w-[86.5%] 3xl:w-[90%] md:ml-auto md:w-full lg:w-full xl:w-full 2xl:w-full 3xl:w-full"
                    : "flex flex-col gap-6 transition-all duration-30 md:w-[72%] lg:w-[79%] xl:w-[84.5%] 2xl:w-[86.5%] 3xl:w-[90%] md:ml-auto"} >
                    <div className="pt-2">
                        <span className="font-rubik font-semibold text-xl text-[#1A1919] md:text-2xl dark:text-[#F5F5F5]" >Games & Survey</span>
                    </div>

                    <div className="bg-white p-6 rounded-2xl transition-all duration-300 games-survey ">
                        <div className="py-2 flex flex-col gap-3 ">
                            <span className="text-[#1A1919] font-rubik font-medium" >Please complete the Games and Questionnaires listed below.</span >
                            <div
                                className="hr w-full h-0.5 bg-[#202A31] opacity-25 dark:bg-[#CED8DF] transition-all duration-300"
                            ></div>
                        </div>

                        <GameSection />

                        <div className="grid gap-6 grid-cols-1 py-6 md:grid-cols-2 lg:grid-cols-3" >


                            {/* <div
                                className="pt-6 pl-6 h-28 bg-[#E5EFF7] flex flex-col gap-1 rounded-lg dark:bg-[#1B75BC66] transition-all duration-300 md:h-40"  >
                                <span className="text-[#1A1919] font-rubik font-medium dark:text-[#F5F5F5]">Game 1</span>
                                <span className="text-[#656575] font-rubik dark:text-[#B7B7B7]">Lorem Ipsum</span>
                            </div>
                            <div className="pt-6 pl-6 h-28 bg-[#E5EFF7] flex flex-col gap-1 rounded-lg dark:bg-[#1B75BC66] transition-all duration-300 md:h-40">
                                <span className="text-[#1A1919] font-rubik font-medium dark:text-[#F5F5F5]">Game 1</span>
                                <span className="text-[#656575] font-rubik dark:text-[#B7B7B7]">Lorem Ipsum</span>
                            </div>
                            <div
                                className="pt-6 pl-6 h-28 bg-[#E5EFF7] flex flex-col gap-1 rounded-lg dark:bg-[#1B75BC66] transition-all duration-300 md:h-40">
                                <span className="text-[#1A1919] font-rubik font-medium dark:text-[#F5F5F5]" >Game 1</span>
                                <span className="text-[#656575] font-rubik dark:text-[#B7B7B7]">Lorem Ipsum</span>
                            </div>
                            <div
                                className="pt-6 pl-6 h-28 bg-[#E5EFF7] flex flex-col gap-1 rounded-lg dark:bg-[#1B75BC66] transition-all duration-300 md:h-40">
                                <span className="text-[#1A1919] font-rubik font-medium dark:text-[#F5F5F5]">Game 1</span>
                                <span className="text-[#656575] font-rubik dark:text-[#B7B7B7]">Lorem Ipsum</span>
                            </div> */}
                        </div>
                    </div >

                    {/* <div className="pb-10 flex flex-col gap-3">
                        <div className="py-2">
                            <span className="font-medium font-rubik text-[#1A1919] dark:text-[#FDFDFD]">
                            User Feedback (Please provide your feedback after completing all the games)
                            </span>
                        </div>

                        <div className="py-4 px-6 bg-[#FDFDFD] dark:bg-[#212121] relative shadow-md rounded-l-sm rounded-r-lg flex flex-col gap-1 transition-all duration-300">
                            <span className="w-3 h-full absolute bg-[#7D7D7D] dark:bg-[#B5B5B5] rounded-sm left-0 top-0 transition-all duration-300"></span>
                            <button
                                className={
                                    questionSubmittedData?.disabledfeedbackButton ?
                                    "rounded bg-[#D3D3D3] py-2 w-[12rem] rounded text-gray-600"
                                    : "rounded bg-[#0198e1] text-[#FFFFFF] py-2 w-[12rem]"
                                }
                                disabled={questionSubmittedData?.disabledfeedbackButton}
                                onClick={() => handleNavigation(questionSubmittedData?.disabledfeedbackButton, 'Feedback')}
                            >
                               {questionSubmittedData?.feedbackSubmitted ? "Feedback submitted" : "Feedback"}
                            </button>
                        </div>
                    </div> */}

                    <div className="pb-10 flex flex-col gap-3">
                        <div className="py-2">
                            <span className="font-medium font-rubik text-[#1A1919] dark:text-[#FDFDFD]">
                                Questionnaire
                            </span>
                        </div>

                        <div className="py-4 px-6 bg-[#FDFDFD] dark:bg-[#212121] relative shadow-md rounded-l-sm rounded-r-lg flex flex-col gap-1 transition-all duration-300">
                            <span className="w-3 h-full absolute bg-[#7D7D7D] dark:bg-[#B5B5B5] rounded-sm left-0 top-0 transition-all duration-300"></span>
                            <button
                                className="rounded bg-[#D3D3D3] text-gray-600 py-2 w-[15%]"
                                disabled={true}
                                // className={
                                //     questionSubmittedData?.disabledsurveyButton
                                //         ? "rounded bg-[#D3D3D3]  text-gray-600 py-2 w-[12rem] "
                                //         : "rounded bg-[#0198e1] text-[#FFFFFF] py-2 w-[12rem]"
                                // }
                                // disabled={questionSubmittedData?.disabledsurveyButton}
                                // onClick={() => handleNavigation(questionSubmittedData?.disabledsurveyButton, 'Questionnaire')}
                            >
                                {questionSubmittedData?.questionnaireSubmitted ? "Questionnaire submitted" : "Take Questionnaire"}
                            </button>
                        </div>
                    </div>


                </div >
            </main >
        </>
    )
}


export default GenericGamesAndSurvey